import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Button, Table, Pagination, Row, Col, Space } from 'antd'
import { CheckCircleOutlined, CloseCircleOutlined, DeleteOutlined, FormOutlined } from '@ant-design/icons'
import { Loading, Page, Panel, Total } from '../../../../../components'
import { BreadcrumbSystem as Breadcrumb, SysPermission } from '../../../../../constants'
import { platformService } from '../../../../../services'
import { auth, validator } from '../../../../../util'
import { SysStore } from '../../../../../stores'

import 'antd/dist/antd.css'
import './styles.css'

const pageSize = 20

/** Rule: Must define breadcrumb in every page **/
const breadcrumb = [
  Breadcrumb.HomeBase,
  Breadcrumb.SoftwareList
]

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 6
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: 13
  },
  {
    width: 2,
    title: 'Active',
    dataIndex: 'active',
    key: 'active',
    render: (active) => active === true
      ? <CheckCircleOutlined style={{color: '#4fbc85', fontSize: '14pt'}} />
      : <CloseCircleOutlined style={{color: '#ccc', fontSize: '14pt'}} />
  },
  {
    width: 3,
    render: (item) => <Space size='middle'>
      { hasAccess(SysPermission.SOFTWARE.INFO.READ)
        ? <Link to={`/softwares/listing/${item.id}`} key={`clasikey${item.id}`}>
          <FormOutlined />
        </Link>
        : null }
    </Space>
  },
]

const hasAccess = (permission) => {
  return auth.hasAccess(permission)
}

function SoftwareList () {
  const [isLoading, setIsLoading] = useState(false)
  const [filter, setFilter] = useState({})
  const [sort, setSort] = useState({})

  useEffect(() => {
    fetchList({ currentPage: 1 })
  }, [])

  const list = SysStore.useState(e => e.sysClassificationList)
  const page = SysStore.useState(e => e.sysClassificationPage)
  const total = SysStore.useState(e => e.sysClassificationTotal)
  const isSysClassificationListLoading = SysStore.useState(e => e.isSysClassificationListLoading)

  async function fetchList ({ currentPage = page }) {
    if (!hasAccess(SysPermission.SOFTWARE.INFO.LIST)) return

    setIsLoading(true)
    const r = await platformService.listByPage(currentPage, pageSize, filter, sort)
    if (r && r.list) {
      setIsLoading(false)
      SysStore.update(e => {
        e.sysClassificationList = r.list
        e.sysClassificationTotal = r.total
        e.sysClassificationPage = currentPage
      })
    }
  }

  return (
    <Page.Body>
      <Page.Breadcrumb item={breadcrumb} />

      <Page.Header title='Softwares'>
        {/* <Link to='/softwares/listing/add'>
          <Button shape='round' type='primary'>Add Software</Button>
        </Link> */}
      </Page.Header>

      <Page.Content>
        <Table
          loading={isLoading}
          columns={columns}
          dataSource={list}
          size='small'
          rowKey={(itm) => (`ptmls${itm.id}`)}
          pagination={{
            hideOnSinglePage: true,
            pageSize,
            total,
            onChange: (e) => fetchList({currentPage: e})
          }}
        />
        <Total total={total} title={'software'} suffix='' />
      </Page.Content>
    </Page.Body>
  )
}

export default SoftwareList
